import { OpenInNewRounded } from "@mui/icons-material";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";

interface IntegrationButtonProps {
    linkTo: string,
    linkTarget?: string,
    label: string,
    isDisabled?: boolean
}
const IntegrationButton = ({linkTo, linkTarget = "_blank", label, isDisabled = false}: IntegrationButtonProps) => {
    const isInternalLink = linkTo.startsWith("/");

    return (
        <Link
            to={isInternalLink ? linkTo : "/"}
            target={isInternalLink ? linkTarget : "_self"}
            style={{textDecorationLine: "none", pointerEvents: isDisabled ? "none" : undefined}}
        >
            <Button variant={"text"} color="accent" endIcon={<OpenInNewRounded/>} disabled={isDisabled}>
                {label}
            </Button>
        </Link>
    );
}

export default IntegrationButton;